import React from 'react';
import './snackBar.scss';
import { HtmlText, formatText } from 'core/i18n';
import IconSuccesCircle from 'assets/icons/icon-success-circle.svg';

function snackBar({ toggleSnackBar }) {
    return (
        <>
            {toggleSnackBar && (
                <div className="snackbar-container">
                    <img className="snackbar-img" src={IconSuccesCircle} alt="success-green" />
                    <p className="snackbar-text">{HtmlText(formatText('modalwelcome-otpRetrySnackbar'))}</p>
                </div>
            )}
        </>
    );
}

export default snackBar;
